import { SagaIterator } from 'redux-saga'
import { put, takeLatest, select, all } from 'redux-saga/effects'

import { getShowSwitchToAttachedFormDialog } from '@tabeeb/modules/appConfigState/selectors'

import { Action } from 'redux-actions'
import { RootState } from '@tabeeb/store'
import * as rawActions from '../actions'
import { signalrEvents, signalrConstants } from '../../signalr'
import { getContentForms, getContentFormsForCurrentUser, getCurrentForm } from '../selectors'
import { ContentFormRecord } from '../types'

function* setContentForms(action: ReturnType<typeof rawActions.getContentForms.success>): SagaIterator {
  const { data } = action.response
  yield put(rawActions.updateContentForms(data))
  const currentForm: ReturnType<typeof getCurrentForm> = yield select(getCurrentForm)
  const forms: ReturnType<typeof getContentFormsForCurrentUser> = yield select(getContentFormsForCurrentUser)

  yield put(rawActions.updateContentForms(forms))
  if (currentForm.Id && forms.some((cf) => cf.Id === currentForm.Id)) {
    if (forms.length > 0) {
      yield put(rawActions.getFormControls.request({ contentFormId: currentForm.Id }))
    }
  } else if (forms.length > 0) {
    yield put(rawActions.getFormControls.request({ contentFormId: forms[0].Id }))
  }
}

function* getContentFormSuccess(action: ReturnType<typeof rawActions.getContentForm.success>): SagaIterator {
  let showSwitchToAttachedFormDialog: ReturnType<typeof getShowSwitchToAttachedFormDialog> = yield select(
    getShowSwitchToAttachedFormDialog
  )
  const form = action.response.data
  if (!form) {
    return
  }
  yield put(rawActions.addContentForm(form))

  const contentForms: ReturnType<typeof getContentForms> = yield select(getContentForms)
  const { lastAttachedForm, infoMessageCondition }: RootState['forms'] = yield select((state) => state.forms)

  if (contentForms.length === 1) {
    yield put(rawActions.getFormControls.request({ contentFormId: contentForms[0].Id }))
  }

  if (lastAttachedForm.isAttachedFromCondition && !infoMessageCondition.isDialogOpen) {
    if (typeof showSwitchToAttachedFormDialog === 'undefined') showSwitchToAttachedFormDialog = true

    if (showSwitchToAttachedFormDialog) {
      yield put(rawActions.openSwitchFormDialog())
    }
  }
}

function* checkLastAttachedForm() {
  let showSwitchToAttachedFormDialog: ReturnType<typeof getShowSwitchToAttachedFormDialog> = yield select(
    getShowSwitchToAttachedFormDialog
  )
  const { lastAttachedForm }: RootState['forms'] = yield select((state) => state.forms)

  if (lastAttachedForm.isAttachedFromCondition) {
    if (typeof showSwitchToAttachedFormDialog === 'undefined') showSwitchToAttachedFormDialog = true
    if (showSwitchToAttachedFormDialog) {
      yield put(rawActions.openSwitchFormDialog())
    }
  }
}

function* onFormRecordCreated(action: Action<[ContentFormRecord]>): SagaIterator {
  const [model] = action.payload
  const currentForm: ReturnType<typeof getCurrentForm> = yield select(getCurrentForm)

  if (model.ContentFormId === currentForm.Id) {
    yield put(rawActions.addFormRecord(model))
  }
}

function* onFormRecordDeleted(action: Action<[ContentFormRecord]>): SagaIterator {
  const [model] = action.payload
  const currentForm: ReturnType<typeof getCurrentForm> = yield select(getCurrentForm)

  if (model.ContentFormId === currentForm.Id) {
    yield put(rawActions.removeFormRecord(model.Id))

    if (currentForm.selectedRecord === model.Id) {
      yield put(rawActions.setSelectedRecord(0))
    }
  }
}

function* contentFormsSaga() {
  yield all([
    takeLatest(rawActions.getContentForms.success, setContentForms),
    takeLatest(rawActions.getContentForm.success, getContentFormSuccess),
    takeLatest(rawActions.checkLastAttachedForm, checkLastAttachedForm),
    takeLatest(signalrEvents[signalrConstants.tabeebHubName].onFormRecordCreated, onFormRecordCreated),
    takeLatest(signalrEvents[signalrConstants.tabeebHubName].onFormRecordDeleted, onFormRecordDeleted),
  ])
}

export default contentFormsSaga
